import { AuthLevel, generateBaseApiContext } from '@guiker/react-framework'
import { PublicApiClient } from '@guiker/user-enquiry-shared'

export const { useContext: useUserEnquiryApiClient, ContextProvider: PublicUserEnquiryContextProvider } =
  generateBaseApiContext({
    authLevel: AuthLevel.PUBLIC,
    apiClientGen: PublicApiClient,
  })
